export default {
  getMediaStream() {
    this.setStreamConfig();

    const stream = new MediaStream();
    this.localTracks.forEach(track => stream.addTrack(track._mediaStreamTrack));
    return { stream };
  }
}
